export default {
  listLatestClient(params) {
    return Request.get('api/news/latest', params);
  },

  show(id) {
    return Request.get(`api/news/${id}/client`);
  },

  list(params) {
    return Request.get('api/news/client', params);
  },
};
